import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/common/auth'

import Home from '@/views/home'
import Authorized from '@/views/authorized'
import AcessoNegado from '@/views/acessonegado'
import Perfil from '@/views/perfil'
import ConfirmarCadastro from '@/views/confirmarcadastro'
import RedefinirSenha from '@/views/redefinirsenha'
import Cadastro from '@/views/cadastro'
import NovoCadastro from '@/views/novocadastro'
import Template from '@/template'
import EsqueciSenha from '@/views/esquecisenha'
import TrocarSenha from '@/views/esquecisenha/trocarsenha'

import routersgenerated from './generated'

Vue.use(Router)

let childrens = routersgenerated.concat([
    {
        path: 'home',
        name: 'Home',
        component: Home
    },
    {
        path: '/perfil/:id',
        name: 'perfil',
        component: Perfil,
    },
    {
        path: '/redefinirsenha/:id',
        name: 'redefinirsenha',
        component: RedefinirSenha,
    },
    {
        path: '/confirmarcadastro/:id/:usuario',
        name: 'confirmarcadastro',
        component: ConfirmarCadastro,
    },
]);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/authorized',
            name: 'authorized',
            component: Authorized,
        },
        {
            path: '/acessonegado',
            name: 'acessonegado',
            component: AcessoNegado,
        },
        {
            path: '/cadastro',
            name: 'cadastro',
            component: Cadastro,
        },
        {
            path: '/novocadastro',
            name: 'novocadastro',
            component: NovoCadastro,
        },
        {
            path: '/esquecisenha',
            name: 'esquecisenha',
            component: EsqueciSenha,
        },
        {
            path: '/esquecisenha/trocarsenha',
            name: 'trocarsenha',
            component: TrocarSenha,
        },
        {
            path: '/',
            redirect: '/home',
            component: Template,
            meta: { requiresAuth: true },
            children: childrens
        },
    ]
})

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        if (!Auth.logged()) {
            Auth.login(true);
            return;
        }

        if (!Auth.canAccess(to.path)) {
            next('/acessonegado')
            return;
        }
    }
    next();
});


export default router;
